"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CatalogueOfferLabel = void 0;
var _CatalogueOfferTooltip = require("./CatalogueOfferTooltip");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const CatalogueOfferLabel = ({
  tooltipTitle,
  catalogueLabel,
  catalogueUrl,
  children,
  offerLabelSmallerOnMobile
}) => {
  if (catalogueLabel && catalogueUrl) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CatalogueOfferTooltip.CatalogueOfferTooltip, {
      offerLabelSmallerOnMobile: offerLabelSmallerOnMobile,
      title: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [`${tooltipTitle} `, /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.CatalogueLink, {
          href: catalogueUrl,
          children: catalogueLabel
        })]
      }),
      children: children
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_CatalogueOfferTooltip.CatalogueOfferTooltip, {
    title: tooltipTitle,
    children: children
  });
};
exports.CatalogueOfferLabel = CatalogueOfferLabel;
